import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import { Box } from "@mui/material";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

const formatAxisDollar = (v) => (Math.abs(v) >= 1000 ? `A$${(v / 1000).toFixed(1)}K` : `A$${v}`);

const RevenueChart = ({ labels, salesOrderRevenue, quotationValue }) => {
  const data = {
    labels,
    datasets: [
      {
        label: "Sales order revenue",
        data: salesOrderRevenue,
        borderColor: "#6d2f9c",
        backgroundColor: "rgba(109,47,156,0.08)",
        fill: true,
        tension: 0.35,
        pointRadius: 3,
        pointBackgroundColor: "#6d2f9c",
      },
      {
        label: "Quotation value",
        data: quotationValue,
        borderColor: "#1D9E75",
        backgroundColor: "rgba(29,158,117,0.06)",
        fill: true,
        tension: 0.35,
        pointRadius: 3,
        pointBackgroundColor: "#1D9E75",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: { duration: 900, easing: "easeOutQuart" },
    plugins: {
      legend: { position: "top", align: "end", labels: { boxWidth: 10, usePointStyle: true } },
    },
    scales: {
      y: {
        grid: { color: "#e7e2e9" },
        ticks: { callback: formatAxisDollar },
      },
      x: { grid: { display: false } },
    },
  };

  return (
    <Box sx={{ position: "relative", height: 230 }}>
      <Line data={data} options={options} />
    </Box>
  );
};

export default RevenueChart;
